import { createAsyncThunk } from "@reduxjs/toolkit"
import { AppId, AppThunkAPIType } from "../../../../app/appTypes"
import { deleteWithAuth, getWithAuth, postWithAuth, putWithAuth } from "../../../../http"

export interface DocumentReference {
    id: number
    documentId: number
    referencedDocumentId: number | null
    referencedDocumentNumber: string | null
    referencedDocumentTitle: string | null
    referenceType: string | null
    referenceNumber: string | null
    title: string | null
    url: string | null
    description: string | null
    guid: string
}

export interface DocumentReferenceSaveDto {
    referencedDocumentId: number | null
    referenceType: string | null
    referenceNumber: string | null
    title: string | null
    url: string | null
    description: string | null
}

export const loadDocumentReferences = createAsyncThunk<DocumentReference[], { documentId: AppId; }, AppThunkAPIType>("document-references/loadDocumentReferences",
    async ({ documentId }, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({
            url: `api/document-references/${documentId}`,
        }))
        const { payload } = result
        if (getWithAuth.fulfilled.match(result)) {
            return payload as DocumentReference[]
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })

export const loadDocumentReference = createAsyncThunk<DocumentReference, { documentId: AppId; id: AppId }, AppThunkAPIType>("document-references/loadDocumentReference",
    async ({ documentId, id }, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({
            url: `api/document-references/${documentId}/references/${id}`,
        }))
        const { payload } = result
        if (getWithAuth.fulfilled.match(result)) {
            return payload as DocumentReference
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })

export const createDocumentReference = createAsyncThunk<DocumentReference, { documentId: AppId; dto: DocumentReferenceSaveDto }, AppThunkAPIType>("document-references/createDocumentReference",
    async ({ documentId, dto }, { dispatch, rejectWithValue }) => {
        const result = await dispatch(postWithAuth({
            url: `api/document-references/${documentId}/references`,
            payload: dto,
        }))
        const { payload } = result
        if (postWithAuth.fulfilled.match(result)) {
            return payload as DocumentReference
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })

export const updateDocumentReference = createAsyncThunk<DocumentReference, { documentId: AppId; id: AppId; dto: DocumentReferenceSaveDto }, AppThunkAPIType>("document-references/updateDocumentReference",
    async ({ documentId, id, dto }, { dispatch, rejectWithValue }) => {
        const result = await dispatch(putWithAuth({
            url: `api/document-references/${documentId}/references/${id}`,
            payload: dto,
        }))
        const { payload } = result
        if (putWithAuth.fulfilled.match(result)) {
            return payload as DocumentReference
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })

export const deleteDocumentReference = createAsyncThunk<AppId, { documentId: AppId; id: AppId }, AppThunkAPIType>("document-references/deleteDocumentReference",
    async ({ documentId, id }, { dispatch, rejectWithValue }) => {
        const result = await dispatch(deleteWithAuth({
            url: `api/document-references/${documentId}/references/${id}`,
        }))
        const { payload } = result
        if (deleteWithAuth.fulfilled.match(result)) {
            return id
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })